import { Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { createListStore } from "../../common/listStore";
import { renderListStore } from "../../common/listStoreUi";
import { renderClose } from "../../common/dialog";
import { useState } from "react";
import { CustomerDto } from "./types";
import { customerDialogTitle, useCustomerBasicInfo } from "./common";
import { UseEntityStore } from "../../common/entityStore";

export interface HistoryDto {
    productCode: string;
    projectCode: string;
    ordId: number;
    date: string;
    actType: string;
    actDesc: string;
    userName: string;
}

export function CustomerHistoryDialog(props: {
    close: () => void;
    useCustomerStore: UseEntityStore<CustomerDto>;
}) {
    const customer = useCustomerBasicInfo(props.useCustomerStore);
    const [useHistoriesStore] = useState(() => createListStore<HistoryDto>({
        path: "customers/histories/" + customer.id, addIndexId: true, listProps: [
            { column: "productCode", label: "Prod", width: 80 },
            { column: "projectCode", label: "Proj", width: 80 },
            { column: "ordId", label: "Ord", width: 80 },
            { column: "date", label: "Date", width: 110, type: "date" },
            { column: "actType", label: "Action", width: 200 },
            { column: "actDesc", label: "Description", width: 500 },
            { column: "userName", label: "User name", width: 110 },
        ]
    }));
    return <>
        <DialogTitle>{customerDialogTitle("Customer history", customer)}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            {renderListStore(useHistoriesStore)}
        </DialogContent>
        <DialogActions>
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
}
